<!--手机端新闻中心-->
<template>
  <div>
    <!--logo-->
    <div class='logo'>
      <img src='../../assets/images/logo.png'>
    </div>

    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="homePage">
        </el-tab-pane>
        <el-tab-pane label="主营业务" name="mainBusiness">
        </el-tab-pane>
        <el-tab-pane label="经典案例" name="case"></el-tab-pane>
        <el-tab-pane label="新闻与资讯" name="newsCenter">
          <div>
            <el-row>
              <div>
                <ul class='buts'>
                  <li>
                    <el-button class='but' type="success" @click='jump(1)'> 公司新闻 </el-button>
                  </li>
                  <li>
                    <el-button class='but' type="success" @click='jump(2)'> 行业资讯 </el-button>
                  </li>
                  <li>
                    <el-button class='but' type="success" @click='jump(3)'> 埃文博士观点 </el-button>
                  </li>
                </ul>
              </div>
              <!--新闻标题-->
              <div class='titleList' v-show="corporation_visible">
                <ul >
                  <li  v-for='item in homeCaseDataList' :key='item.id' @click="doctor(item)">
                    {{ item.title }}
                  </li>
                </ul>
                <!--分页-->
                <el-pagination class='pag'
                               small
                               layout="prev, pager, next"
                               next-text="下一页"
                               prev-text="上一页"
                               :page-size="1"
                               @prev-click='upPage'
                               @next-click='upPage'
                               @current-change='upPage'
                               :total='total'
                               :page.sync='queryParams.pageNum'
                >
                </el-pagination>
              </div>
              <div class='titleList' v-show="trade_visible">
                <ul >
                  <li  v-for='item in industryDataList' :key='item.id' @click="doctor(item)">
                    {{ item.title }}
                  </li>
                </ul>
                <!--分页-->
                <el-pagination class='pag'
                               small
                               layout="prev, pager, next"
                               next-text="下一页"
                               prev-text="上一页"
                               :page-size="1"
                               @prev-click='upPage'
                               @next-click='upPage'
                               @current-change='upPage'
                               :total='industryTotal'
                               :page.sync='industryParams.pageNum'
                >
                </el-pagination>
              </div>
              <div class='titleList' v-show="doctor_visible">
                <ul >
                  <li  v-for='item in doctorDataList' :key='item.id' @click="doctor(item)">
                    {{ item.title }}
                  </li>
                </ul>
                <!--分页-->
                <el-pagination class='pag'
                               small
                               layout="prev, pager, next"
                               next-text="下一页"
                               prev-text="上一页"
                               :page-size="1"
                               @prev-click='upPage'
                               @next-click='upPage'
                               @current-change='upPage'
                               :total='doctorTotal'
                               :page.sync='doctorParams.pageNum'
                >
                </el-pagination>
              </div>

            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="研究院" name="researchInstitute">研究院</el-tab-pane>
        <el-tab-pane label="关于埃文" name="avi">关于埃文</el-tab-pane>
      </el-tabs>
      <!--底部占位-->
      <div style='height: 80px;'>
      </div>
    </template>

    <!--底部选项卡-->
    <div class='bottom'>
      <ul>
        <li class='tab' @click="tabButton(1)">联系方式</li>
        <li class='tab' @click="tabButton(2)">加入低碳行业</li>
        <li class='tab' @click="tabButton(3)">合作网站</li>
      </ul>
      <p>企业节能减排与低碳发展综合解决方案提供商</p>
    </div>
  </div>
</template>

<script>
import { webQueryAll } from '@api/auth'

export default {
  created () {
    this.jump(1)
  },
  data () {
    return {
      corporation_visible: false,
      trade_visible: false,
      doctor_visible: false,
      homeCaseDataList: [],
      industryDataList: [],
      doctorDataList: [],
      // 总条数
      total: 0,
      industryTotal: 0,
      doctorTotal: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        type: 1
      },
      industryParams: {
        pageNum: 1,
        pageSize: 20,
        type: 1
      },
      activeName: 'newsCenter',
      doctorParams: {
        pageNum: 1,
        pageSize: 20,
        type: 1
      },
      carouselIndustryParams: {
        type: 5
      },
      carouselParams: {
        type: 5
      },
      carouselDoctorParams: {
        type: 5
      }
    }
  },
  methods: {
    tabButton (raw) {
      if (raw === 1) {
        // 联系方式
        this.$router.push({
          path: '/mobileContacInformation',
          query: {}
        })
      } else if (raw === 2) {
        // 加入低碳
        this.$router.push({
          path: '/moblielowCarbonIndustry',
          query: {}
        })
      } else if (raw === 3) {
        // 合作伙伴
        this.$router.push({
          path: '/mobileCooperativePartner',
          query: {}
        })
      }
    },
    handleClick (tab, event) {
      if (tab.name === 'homePage') {
        this.$router.push({
          path: '/mobileIndex',
          query: {
          }
        })
      } else if (tab.name === 'mainBusiness') {
        this.$router.push({
          path: '/mobileMainBusiness',
          query: {
          }
        })
      } else if (tab.name === 'case') {
        this.$router.push({
          path: '/mobileCase',
          query: {
          }
        })
      } else if (tab.name === 'researchInstitute') {
        this.$router.push({
          path: '/mobileResearchInstituter',
          query: {
          }
        })
      } else if (tab.name === 'avi') {
        this.$router.push({
          path: '/mobileAboutAvi',
          query: {
          }
        })
      } else if (tab.name === 'newsCenter') {
        this.$router.push({
          path: '/mobileNewsCenter',
          query: {
          }
        })
      }
    },
    doctor (raw) {
      this.$router.push({
        path: '/mobileDetailsPage',
        query: {
          id: raw.id,
          type: 2
        }
      })
    },
    upPage (raw) {
      this.queryParams.pageNum = raw
      this.webQueryAll(1)
    },
    jump (raw) {
      if (raw === 1) {
        if (this.homeCaseDataList.length === 0) {
          this.webQueryAll(1)
        }
        this.trade_visible = false
        this.doctor_visible = false
        if (this.corporation_visible) {
          this.corporation_visible = false
        } else {
          this.corporation_visible = true
        }
      } else if (raw === 2) {
        if (this.industryDataList.length === 0) {
          this.industryAll(2)
        }
        this.corporation_visible = false
        this.doctor_visible = false
        if (this.trade_visible) {
          this.trade_visible = false
        } else {
          this.trade_visible = true
        }
      } else if (raw === 3) {
        if (this.doctorDataList.length === 0) {
          this.doctorAll(3)
        }
        this.trade_visible = false
        this.corporation_visible = false
        if (this.doctor_visible) {
          this.doctor_visible = false
        } else {
          this.doctor_visible = true
        }
      }
    },
    /** 公司新闻 */
    // eslint-disable-next-line vue/no-dupe-keys
    webQueryAll (type) {
      let that = this
      that.queryParams.type = type
      webQueryAll(that.queryParams).then(res => {
        res.records.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        this.total = res.pages
        this.homeCaseDataList = res.records
      })
    },
    /** 行业新闻 */
    // eslint-disable-next-line vue/no-dupe-keys
    industryAll (type) {
      let that = this
      that.industryParams.type = type
      webQueryAll(that.industryParams).then(res => {
        res.records.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        this.industryTotal = res.pages
        this.industryDataList = res.records
      })
    },
    /** 埃文博士 */
    // eslint-disable-next-line vue/no-dupe-keys
    doctorAll (type) {
      let that = this
      that.doctorParams.type = type
      webQueryAll(that.doctorParams).then(res => {
        res.records.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        this.doctorTotal = res.pages
        this.doctorDataList = res.records
      })
    }
  }
}

</script>

<style lang="less" scoped>

//按钮
.buts{
  width: 90%;
  margin: 0 auto;
  height:65px ;
  li{
    width: 33.33%;
    float: left;
    padding: 0 5px;
  }
  .but{
    background-color: #90bc4f;
    margin: 15px auto;
    width: 100%;
    font-size: 14px;
    height: 30px;
    line-height: 0px;
    padding: 0;
    letter-spacing:1px;
    border-radius:10px ;
    box-shadow: 0 5px 5px  rgba(0, 0, 0, .2);
  }
}

//标题列表
.titleList{
  width: 90%;
  margin: 0 auto 10px;
  font-size: 14px;
  text-align: center;
  min-height: 360px;
  li{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
    font-family: SourceHanSansSC;
    overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
    text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
    white-space: nowrap; /*文本不换行*/
    cursor:pointer;
  }
}
//分页
.pag{
  margin: 0 auto;
  text-align: center;
}
.el-row {
  &:last-child {
    margin-bottom: 0px;
  }
}

//logo
.logo{
  img{
    width: 70%;
    display: block;
    margin:10px auto;
  }
}

//tabs样式
::v-deep .el-tabs__item {
  border: 1px solid #fff;
  background-color: #90bc4f;
  width: 33.33%;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  float: left;
  display: block;
  text-align: center;
}
::v-deep .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}
::v-deep .el-tabs__item.is-top:nth-child(7) {
  padding-left: 0px;
}

.videoTitle{
  height: 300px;
  width: 90%;
  margin: 0 auto;
  p{
    height: 30px;
    width: 100%;
    background: url("../../assets/images/homePage/edge1.png") center  center no-repeat;
    img{
      display: block;
      margin: 0 auto;
      cursor:pointer;
    }
  }
  ul{
    height: 240px;
    li{
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-family: SourceHanSansSC;
      overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
      text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
      white-space: nowrap; /*文本不换行*/
      cursor:pointer;
    }
  }
}
.videoPlayer {
  height: 300px;
  width: 200px;
  margin: 0 auto;
}
//底部选项卡
.bottom{
  background-color: #fff;
  height: 80px;
  width: 100%;
  position: fixed;
  bottom: 0;
  .tab{
    width: 33.33%;
    float: left;
    text-align: center;
    background-color: #90bc4f;
    border: 1px solid #fff;
    font-size: 14px;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }
  p{
    font-size: 14px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color:#90bc4f;
  }
}
::v-deep .el-tab-pane{
  height:100%;
}
//tabs鼠标移入事件
::v-deep .el-tabs__item:hover{
  color: #6aa84f;
}
//tabs鼠标点击事件
::v-deep .el-tabs__item.is-active {
  color: #fff !important;
  background-color:#6aa84f !important;
}
//去掉tab下划线
::v-deep .el-tabs__active-bar {
  width: 0px !important;
}
</style>
